<h2 mat-dialog-title>
    {{title}}
    <button class="close-button" (click)="onCancel()" disableRipple>
        <span class="material-symbols-outlined">close</span>
    </button>
</h2>

<mat-dialog-content class="mat-typography custom-dialog">
    <div class="training-details">
        <div class="names">
            <div class="details">
                <span class="label">Competency Name:</span>
                <span class="value">{{ trainingDetails.competency }}</span>
            </div>
            <div class="details">
                <span class="label">Session Name:</span>
                <span class="value">{{ trainingDetails.sessionName }}</span>
            </div>
        </div>
        <div class="date-ranges">
            <div class="details">
                <span class="label">Start Date:</span>
                <mat-form-field class="datepicker">
                    <input
                        matInput
                        [matDatepicker]="picker1"
                        placeholder="Start Date"
                        [(ngModel)]="trainingDetails.startDate"
                        [disabled]="true"
                    >
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker
                        aria-placeholder="Start Date"
                        #picker1
                        [disabled]="true"
                    ></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="details">
                <span class="label">End Date:</span>
                <mat-form-field class="datepicker">
                    <input
                        matInput
                        [matDatepicker]="picker2"
                        placeholder="End Date"
                        [(ngModel)]="endDate"
                        [disabled]="readOnly"
                        readonly
                        [matDatepickerFilter]="validateEndDate"
    
                    >
                    <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                    <mat-datepicker
                        aria-placeholder="End Date"
                        #picker2
                        [disabled]="readOnly"
                    ></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="training-status">
            <div>
                <span class="label">Status:</span>
                <span class="value">{{ trainingDetails.trainingStatusDescription }}</span>
            </div>
        </div>
    </div>
    <div class="emp-table">
        <mat-table [dataSource]="employees" class="fixed-table">
            <ng-container matColumnDef="employeeId">
                <mat-header-cell *matHeaderCellDef class="alignment">
                    <div class="filter-heading">
                        <div>Employee Id</div>
                        <ng-container
                            *ngTemplateOutlet="
                                filterTemplate;
                                context: { head: { Name: 'employeeId' }, options: filterOptions.employeeId }
                            "
                        ></ng-container>
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.employeeId }} </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="employeeName">
                <mat-header-cell *matHeaderCellDef class="alignment">
                    <div class="filter-heading">
                        <div>Employee Name</div>
                        <ng-container
                            *ngTemplateOutlet="
                                filterTemplate;
                                context: { head: { Name: 'employeeName' }, options: filterOptions.employeeName }
                            "
                        ></ng-container>
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ getEmloyeeName(row) }} </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef> Email ID </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.email }} </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef class="alignment">
                    <div class="filter-heading">
                        <div>Status</div>
                        <ng-container
                            *ngTemplateOutlet="
                                filterTemplate;
                                context: { head: { Name: 'status' }, options: filterOptions.status }
                            "
                        ></ng-container>
                    </div>
                </mat-header-cell>
                <mat-cell *matCellDef="let row"> {{ row.status }} </mat-cell>
            </ng-container>
    
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef > Action </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <a class="action-link" (click)="removeEmployee(row)">Remove</a>
                </mat-cell>
            </ng-container>
    
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row
                [class.odd]="i % 2 == 1"
                [class.even]="i % 2 == 0"
                *matRowDef="let row; columns: displayedColumns; let i = index;"
            >
            </mat-row>
        </mat-table>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="review">
    <button class="btn btn-outline btn-spacing" (click)="onCancel()">
        Close
    </button>

    <button (click)="updateTraining()" class="btn btn-primary">
        Submit
    </button>
</mat-dialog-actions>

<ng-template #filterTemplate let-head="head" let-options="options">
    <div>
        <span
            class="material-symbols-outlined filter-icon"
            (click)="openCloseFilter(head.Name)"
        >
            filter_alt
        </span>
    </div>
    <div
        class="filter-container"
        tabindex="1"
        *ngIf="filterColumns[head.Name]"
    >
        <div>
            <span
                class="material-symbols-outlined clearIcon"
                (click)="openCloseFilter(head.Name)"
            >
                close
            </span>
        </div>
        <input
            #input
            type="text"
            mat-input
            (input)="searchOptions(input.value,head.Name)"
            class="form-control search-Text"
            placeholder="Search {{head.Name}}"
        />
        <div class="filterOptions" *ngFor="let option of options">
            <mat-checkbox
                class="check-box"
                [(ngModel)]="option.isChecked"
                (ngModelChange)="onOptionChange($event, option, head.Name)"
            >{{option.name}}</mat-checkbox>
        </div>
    </div>
</ng-template>